import * as React from "react";
import { Text } from "@grandvisionhq/elements";
import { CategoryGroup } from "@grandvisionhq/my-account";
import { useIntl } from "@grandvisionhq/state";
import { pushWishlistEvent } from "../../../../../../data-layer/data-layer/wishlist.js";
import WishlistItem from "./WishlistItem.js";
/* empty css              */
const Wishlist = ({
  isUpdateLoading,
  wishlistLabels,
  items,
  isMyAccountEnabled,
  onUpdateWishList
}) => {
  const { getLabel } = useIntl();
  const [skuToRemove, setSkuToRemove] = React.useState("");
  const labels = {
    introEmpty: getLabel("account.wishlist.intro.empty"),
    introFull: wishlistLabels.introFull,
    login: wishlistLabels.login
  };
  const onRemoveWishlistItem = (sku) => {
    setSkuToRemove(sku);
    onUpdateWishList(sku);
  };
  const onLoginLabelClick = () => {
    pushWishlistEvent({
      siteFeature: "my_account",
      interactionType: "wishlist_login_register_click"
    });
  };
  return /* @__PURE__ */ React.createElement("div", { className: "wishlist" }, /* @__PURE__ */ React.createElement(Text, null, !items?.length ? labels.introEmpty : labels.introFull), labels.login && isMyAccountEnabled ? /* @__PURE__ */ React.createElement(Text, { onClick: onLoginLabelClick }, labels.login) : null, items?.map((item) => /* @__PURE__ */ React.createElement(
    WishlistItem,
    {
      key: item.sku,
      item,
      isUpdateLoading: isUpdateLoading && skuToRemove === item.sku,
      onUpdateWishList: () => onRemoveWishlistItem(item.sku)
    }
  )), !items?.length ? /* @__PURE__ */ React.createElement(CategoryGroup, null) : null);
};
export {
  Wishlist as default
};
//# sourceMappingURL=Wishlist.js.map
